import script from "./AdvertiserModalSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvertiserModalSlide.vue?vue&type=script&setup=true&lang=js"

import "./AdvertiserModalSlide.vue?vue&type=style&index=0&id=66731cb7&lang=scss"

const __exports__ = script;

export default __exports__